
export default {
  props: {
    value: {
      default: () => new Date(),
    },
    range: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    date: {
      get() {
        return this.value;
      },
      set(value) {
        let result = value;
        if (this.range) {
          result = value.sort((a, b) => new Date(a) - new Date(b));
        }
        this.$emit('input', result);
      },
    },
    selectedItemsText() {
      let date = this.value[0];
      if (this.value.length > 1) {
        date = `${this.value[0].slice(2)} - ${this.value[1].slice(2)}`;
      }
      return date;
    },
  },
};
